import React from 'react';
import classnames from 'classnames';
import { ApplicationView } from '@aha-app/mvc';
import type { Item } from '@aha-app/selectro-v2';
import SelectroV2TagsTriggerTemplate from '../../../SelectroV2/Templates/SelectroV2TagsTriggerTemplate';

interface TriggerTemplateProps {
  noneSelected: string;
  editable?: boolean;
  showInput?: boolean;
  focusing?: boolean;
  class?: string;
  items: Item[];
  callSelectCallbackOnRemove?: boolean;
}

const SelectroV2InPlaceTagsTriggerTemplate: React.FC<TriggerTemplateProps> = ({
  editable,
  callSelectCallbackOnRemove = false,
  items,
  ...props
}) => (
  <SelectroV2TagsTriggerTemplate
    noneSelected={props.noneSelected}
    callSelectCallbackOnRemove={callSelectCallbackOnRemove}
    items={items}
    editable={editable}
    className={`${props.class} ${classnames({
      'react-in-place': true,
      'react-in-place__placeholder': true,
      'react-in-place--empty': !items?.length,
      'react-in-place--active': props.showInput || props.focusing,
      'react-in-place--disabled': !editable,
    })}
    `}
  />
);

export default ApplicationView(SelectroV2InPlaceTagsTriggerTemplate);
